/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Legal_Privacy_AcceptedInputs */

const en_auth_legal_privacy_accepted = /** @type {(inputs: Auth_Legal_Privacy_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy Policy`)
};

const pl_auth_legal_privacy_accepted = /** @type {(inputs: Auth_Legal_Privacy_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Politykę prywatności`)
};

/**
* | output |
* | --- |
* | "Privacy Policy" |
*
* @param {Auth_Legal_Privacy_AcceptedInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const auth_legal_privacy_accepted = /** @type {((inputs?: Auth_Legal_Privacy_AcceptedInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Legal_Privacy_AcceptedInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_auth_legal_privacy_accepted(inputs)
	return en_auth_legal_privacy_accepted(inputs)
});